<template>
  <div
    :id="id"
    class="modal-add modal-api-manager"
  >
    <div class="modal-title">
      <h4 class="title">{{ dataApi ? 'Edit' : 'Add' }} API Manager</h4>
    </div>

    <div class="wrap-content-modal">
      <b-form-group
        :class="{'error-input' : $v.dataSetup.name.$error}"
        class="mb-1"
      >
        <label> API Name </label>
        <j-input
          v-model="dataSetup.name"
          :error-required="false"
          placeholder="Input API Name"
        />
      </b-form-group>
      <div class="row">
        <div class="col-4">
          <b-form-group
            :class="{'error-input' : $v.dataSetup.method.$error}"
            class="mb-1"
          >
            <label> Method </label>
            <j-single-select
              v-model="dataSetup.method"
              :options="methodOptions"
              :error-required="false"
              :class="dataSetup.method"
              placeholder="Select Method API"
              label="name"
            />
          </b-form-group>
        </div>
        <div class="col-8 pl-0">
          <b-form-group
            :class="{'error-input' : $v.dataSetup.url.$error}"
            class="mb-1"
          >
            <label> URL </label>
            <j-input
              v-model="dataSetup.url"
              :error-required="false"
              placeholder="Enter URL/Endpoint"
            />
          </b-form-group>
        </div>
      </div>

      <!-- Tab -->
      <div class="api-tab">
        <div
          v-for="tab in tabs"
          :key="tab.id"
          :class="{'active': tab.id === tabActive}"
          class="tab"
          @click="tabActive = tab.id"
        >
          {{ tab.label }}
        </div>
      </div>

      <!-- Header -->
      <div
        v-if="tabActive === 'header'"
        class="api-header"
      >
        <div
          v-for="(header, index) in dataSetup.header"
          :key="`header-${index}`"
          class="header-list"
        >
          <input
            v-model="header.name"
            type="text"
            placeholder="Name"
          >
          <input
            v-model="header.value"
            type="text"
            placeholder="Value"
          >
          <i
            class="fa fa-trash"
            @click="deleteHeader(index)"
          />
        </div>
        <div
          class="add-header"
          @click="addHeader"
        >
          + Add Header
        </div>
      </div>

      <!-- Params -->
      <div
        v-if="tabActive === 'params'"
        class="api-header"
      >
        <div
          v-for="(param, index) in dataSetup.params"
          :key="`header-${index}`"
          class="header-list"
        >
          <input
            v-model="param.variable"
            type="text"
            placeholder="Variable"
          >
          <input
            v-model="param.value"
            type="text"
            placeholder="Value"
          >
          <i
            class="fa fa-trash"
            @click="deleteParams(index)"
          />
        </div>
        <div
          class="add-header"
          @click="addParams"
        >
          + Add Params
        </div>
      </div>

      <div class="d-flex justify-content-end mt-4">
        <button
          class="button-border mr-2"
          @click="$emit('close-modal')"
        >
          Close
        </button>
        <button
          class="button-blue mr-2"
        >
          Set
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';

export default {
  props: {
    id: {
      type: String,
      default: '',
    },
    dataApi: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      dataSetup: {
        name: '',
        method: null,
        url: '',
        header: [
          { name: '', value: '' },
        ],
        params: [
          { variable: '', value: '' },
        ],
      },
      methodOptions: [
        { id: 'get', name: 'GET' },
        { id: 'post', name: 'POST' },
        { id: 'delete', name: 'DELETE' },
      ],
      tabs: [
        { id: 'header', label: 'HEADER' },
        { id: 'params', label: 'PARAMS' },
        { id: 'authorization', label: 'AUTHORIZATION' },
        { id: 'body', label: 'BODY' },
      ],
      tabActive: 'header',
    };
  },

  methods: {
    addHeader() {
      this.dataSetup.header.push({ name: '', value: '' });
    },

    deleteHeader(index) {
      this.dataSetup.header.splice(index, 1);
    },

    addParams() {
      this.dataSetup.params.push({ variable: '', value: '' });
    },

    deleteParams(index) {
      this.dataSetup.params.splice(index, 1);
    },
  },

  validations() {
    return {
      dataSetup: {
        name: { required },
        method: { required },
        url: { required },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/application-manager/detail/app-tabs/partials/modal/modalApiManager.vue